import { Stack } from '@fluentui/react';
import React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { AnswerCard } from 'src/languageStudio/appShell/prebuiltDemos/generateQuestionsDemo/AnswerCard';
import { MappedQuestions } from 'src/languageStudio/appShell/prebuiltDemos/generateQuestionsDemo/generateQuestionsSwagger';

export type VisualizedGenerateQuestionsResultProps = {
    generatedQnAs: Map<string, MappedQuestions>;
};

const messages = defineMessages({
    generatedQuestions: {
        id: 'languageStudio.visualizedGenerateQuestionsResult.generatedQuestions',
        defaultMessage: `Generated questions`
    }
});

export const VisualizedGenerateQuestionsResult = (props: VisualizedGenerateQuestionsResultProps) => {
    const { generatedQnAs } = props;
    const { localize } = useLocalization();

    const renderedActionCards = [...generatedQnAs].map(([answer, QnAObject], index) => (
        <AnswerCard answerIndex={index} questions={QnAObject.questions} confidenceScore={QnAObject.confidenceScore} answer={answer} />
    ));

    return (
        <Stack styles={{ root: { width: '100%' } }} tokens={{ childrenGap: 25 }}>
            <Stack tokens={{ childrenGap: 10 }}>
                <LuisText fontWeight={600}>{localize(messages.generatedQuestions)}</LuisText>
            </Stack>

            <Stack data-automation-id="questionGenerationQuestionsCardContainer">{renderedActionCards}</Stack>
        </Stack>
    );
};
